module.exports = __webpack_public_path__ + "static/img/3_1_4.8d8702ec.jpg";